import React, { useState } from 'react';
import { Lightbulb, Loader2, Sparkles } from 'lucide-react';
import api from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Slider } from '@/components/ui/slider';
import { toast } from 'sonner';

function Idees({ marque, choisir }) {
  const [idees, setIdees] = useState([]);
  const [charge, setCharge] = useState(false);
  const proposer = async () => {
    setCharge(true);
    try { setIdees((await api.post('/videos-virales/idees', { marque })).data.idees); }
    catch (e) { toast.error(e.response?.data?.detail || 'Idées indisponibles'); }
    setCharge(false);
  };
  return (
    <div className="space-y-2">
      <Button variant="outline" size="sm" onClick={proposer} disabled={charge} data-testid="vv-proposer-idees">
        {charge ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Lightbulb className="w-4 h-4 mr-2" />}5 idées de l'agent commercial
      </Button>
      {idees.length > 0 && (
        <div className="grid gap-2" data-testid="vv-liste-idees">
          {idees.map((i, k) => (
            <button key={k} type="button" onClick={() => choisir(i.sujet)} data-testid={`vv-idee-${k}`}
              className="text-left rounded-lg border border-stone-200 bg-white p-3 hover:border-primary hover:bg-primary/5 transition-colors">
              <p className="font-medium text-sm">{i.titre}</p>
              <p className="text-xs text-stone-600 mt-0.5">{i.sujet}</p>
              {i.pourquoi && <p className="text-[11px] text-primary mt-1">{i.pourquoi}</p>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export function FormulaireVideo({ config, onCree }) {
  const [marque, setMarque] = useState('bureau_agricole');
  const [sujet, setSujet] = useState('');
  const [duree, setDuree] = useState(10);
  const [envoi, setEnvoi] = useState(false);
  const prix = config?.prix_seconde_usd || 0.14;
  const lancer = async () => {
    setEnvoi(true);
    try {
      await api.post('/videos-virales', { marque, sujet, duree });
      toast.success('Tournage lancé : vous serez prévenu sur Telegram quand elle est prête');
      setSujet('');
      onCree();
    } catch (e) { toast.error(e.response?.data?.detail?.toString() || 'Lancement impossible'); }
    setEnvoi(false);
  };
  return (
    <div className="rounded-2xl border border-stone-200 bg-white p-5 space-y-4" data-testid="vv-formulaire">
      <div className="flex flex-wrap items-center gap-3">
        <Select value={marque} onValueChange={setMarque}>
          <SelectTrigger className="w-56" data-testid="vv-marque"><SelectValue /></SelectTrigger>
          <SelectContent>
            {(config?.marques || []).map((m) => <SelectItem key={m.cle} value={m.cle} data-testid={`vv-marque-${m.cle}`}>{m.nom}</SelectItem>)}
          </SelectContent>
        </Select>
        <Idees marque={marque} choisir={setSujet} />
      </div>
      <Textarea rows={3} value={sujet} onChange={(e) => setSujet(e.target.value)} data-testid="vv-sujet"
        placeholder="Ex : un viticulteur dicte son traitement à Valentine depuis le tracteur, le registre phyto se remplit tout seul" />
      <div className="flex flex-wrap items-center gap-6">
        <div className="flex items-center gap-3 w-72">
          <span className="text-sm text-stone-600 whitespace-nowrap">Durée</span>
          <Slider min={8} max={15} step={1} value={[duree]} onValueChange={([v]) => setDuree(v)} data-testid="vv-duree" />
          <span className="text-sm font-semibold w-10" data-testid="vv-duree-valeur">{duree} s</span>
        </div>
        <span className="text-xs text-stone-500" data-testid="vv-cout-estime">Coût estimé ≈ {(duree * prix).toFixed(2)} $ (son inclus)</span>
        <Button onClick={lancer} disabled={sujet.trim().length < 5 || envoi} className="ml-auto" data-testid="vv-lancer">
          {envoi ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Sparkles className="w-4 h-4 mr-2" />}Tourner la vidéo
        </Button>
      </div>
    </div>
  );
}
